/**
 * Module: lib/abortTimeout
 * Role: Polyfill for AbortSignal.timeout — old WKWebView (iOS <16) lacks it.
 * Uses: (pure browser API)
 * Used by: lib/uploadTelemetry, api/flow-client, lib/imageResize
 */

/**
 * Return an AbortSignal that aborts after `ms` milliseconds.
 * Uses native AbortSignal.timeout when available; else falls back
 * to AbortController + setTimeout.
 */
export function timeoutSignal(ms: number): AbortSignal {
  if (typeof AbortSignal !== 'undefined' && 'timeout' in AbortSignal) {
    return AbortSignal.timeout(ms);
  }
  const ctrl = new AbortController();
  setTimeout(() => ctrl.abort(new DOMException('TimeoutError', 'TimeoutError')), ms);
  return ctrl.signal;
}
